import React from "react";
import "./LoginInput.scss";

interface Props {
  className?: string;
  icon?: string;
  after?: string;
  afterOnClick?: () => void;
  type?: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  required?: boolean;
}

export default (props: Props) => {
  const iconSrc = props.icon;
  const afterSrc = props.after;

  return (
    <div
      className={`LoginInput${props.className ? ` ${props.className}` : ""}`}
    >
      {iconSrc ? (
        <>
          <div className="LoginInput__icon">
            <img src={iconSrc} />
          </div>
          <div className="LoginInput__separator" />
        </>
      ) : null}
      <div className="LoginInput__input">
        <div className="LoginInput__inputContent">
          <input
            type={props.type || "text"}
            value={props.value}
            onChange={(e) => props.onChange(e.target.value)}
            placeholder={props.placeholder}
            required={props.required}
          />
        </div>
        {afterSrc && (
          <div className="LoginInput__inputAfter" onClick={props.afterOnClick}>
            <img src={afterSrc} />
          </div>
        )}
      </div>
    </div>
  );
};
